import { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { useInterval } from './useInterval';
export const useUserTime = (tz) => {
    const [time, setTime] = useState(tz ? moment.tz(moment(), tz).format('h:mm A') : null);
    useEffect(() => {
        setTime(tz ? moment.tz(moment(), tz).format('h:mm A') : null);
    }, [tz]);
    useInterval(() => {
        if (tz)
            setTime(moment.tz(moment(), tz).format('h:mm A'));
    }, tz ? 60 * 1000 : null);
    return time;
};
//# sourceMappingURL=useUserTime.js.map